export const BUSINESS = {
  name: "V.S.V. Agencies",
  city: "Coimbatore",
  state: "Tamil Nadu",
  email: "mavalyan@vsvagencies.com",
  phoneDisplay: "+91 86670 96511",
  whatsapp: "918667096511",
};

export const waLink = (text) =>
  `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(
    text || "Hello V.S.V. Agencies, I would like to enquire about your products."
  )}`;

export const CATEGORIES = [
  {
    id: "silicone",
    brand: "DOWSIL",
    label: "Silicone Sealants",
    accent: "#38bdf8",
    blurb:
      "Authorised dealers of DOWSIL™ architectural & industrial silicone sealants — engineered by Dow for weatherproofing, glazing and sanitary applications.",
    image:
      "https://5.imimg.com/data5/OU/LO/FU/SELLER-64703837/dowsil-gp-1000x1000.jpg",
  },
  {
    id: "dhal",
    brand: "Chennai Express",
    label: "Urad Dhal",
    accent: "#facc15",
    blurb:
      "Distributors of Chennai Express premium urad dhal (black gram) — cleaned, graded and packed for wholesale, retail and food-service supply.",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_web-launch-hub-18/artifacts/4b7k0pr7_71lTIelk3gL.jpg",
  },
  {
    id: "chemicals",
    brand: "Wopper",
    label: "Laundry Chemicals",
    accent: "#e879f9",
    blurb:
      "The Wopper range of laundry liquids, powders and softeners — built for commercial laundries, hospitality and everyday household cleaning.",
    image:
      "https://images.unsplash.com/photo-1639112389900-a858bf671be1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxsYXVuZHJ5JTIwbGlxdWlkJTIwZGV0ZXJnZW50JTIwYm90dGxlfGVufDB8fHx8MTc4Mjk1ODk3OHww&ixlib=rb-4.1.0&q=85",
  },
];
